export default function Footer() {
  return (
    <footer className="bg-black py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
          {/* Left Column */}
          <div>
            <img 
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/ccf689b9a030d4a511e23c69d6ff7870.png" 
              alt="Deluxe AI Systems" 
              className="h-10 w-auto mb-4"
            />
            <p className="text-[#8C9198] font-light text-sm tracking-wide">
              Precision Intelligence. Premium Results.
            </p>
          </div>

          {/* Right Column */}
          <div className="md:text-right">
            <h4 className="text-[#E8EBEF] font-bold text-sm tracking-wider mb-4 uppercase">Navigation</h4>
            <nav className="space-y-3">
              <a href="#industries" className="block text-[#8C9198] hover:text-[#E8EBEF] transition-colors duration-300 text-sm font-light cursor-pointer">
                Industries
              </a>
              <a href="#book" className="block text-[#8C9198] hover:text-[#E8EBEF] transition-colors duration-300 text-sm font-light cursor-pointer">
                Book a Call
              </a>
              <a href="#contact" className="block text-[#8C9198] hover:text-[#E8EBEF] transition-colors duration-300 text-sm font-light cursor-pointer">
                Contact
              </a>
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#8C9198]/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#8C9198] text-xs font-light">
            © 2025 Deluxe AI Systems. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}